// src/components/Forms/CreacionArticuloForm.js

import React, { useState, useEffect } from 'react';

// --- Componente del Formulario ---
function CreacionArticuloForm() {
  // Estados para los campos individuales que construirán la descripción
  const [tipoArticulo, setTipoArticulo] = useState('CUBIERTA');
  const [marca, setMarca] = useState('');
  const [medidas, setMedidas] = useState('');
  const [modelo, setModelo] = useState('');

  // Estado para la descripción final, que se arma automáticamente
  const [descripcion, setDescripcion] = useState('');

  // Estado para guardar el nuevo código que nos devolverá el backend
  const [nuevoCodigoSAP, setNuevoCodigoSAP] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Este efecto actualiza la descripción en tiempo real cuando cambia un campo
  useEffect(() => {
    const nuevaDescripcion = `${tipoArticulo} ${marca} ${medidas} - ${modelo}`.trim();
    setDescripcion(nuevaDescripcion);
  }, [tipoArticulo, marca, medidas, modelo]);

  // --- Función para manejar el envío del formulario ---
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setNuevoCodigoSAP(null);
    setError('');

    const articuloParaCrear = {
      descripcion: descripcion,
      marca: marca,
      // Aquí irían otros campos del formulario
    };

    console.log("Enviando al backend:", articuloParaCrear);
    try {
      // Aquí iría la llamada real a tu API con fetch() o axios
      // Simulamos una respuesta exitosa del backend después de 1.5 segundos
      await new Promise(resolve => setTimeout(resolve, 1500));
      const dataSimulada = { nuevoCodigo: "400123457" };

      if (dataSimulada.nuevoCodigo) {
        setNuevoCodigoSAP(dataSimulada.nuevoCodigo);
      } else {
        throw new Error('Error al crear el artículo.');
      }

    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mt-3">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Tipo:</label>
            <input 
              type="text" 
              className="form-control"
              value={tipoArticulo}
              onChange={(e) => setTipoArticulo(e.target.value.toUpperCase())}
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Marca:</label>
            <input 
              type="text" 
              className="form-control"
              value={marca}
              onChange={(e) => setMarca(e.target.value.toUpperCase())}
              placeholder="Ej: PIRELLI"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Medidas:</label>
            <input 
              type="text" 
              className="form-control"
              value={medidas}
              onChange={(e) => setMedidas(e.target.value.toUpperCase())}
              placeholder="Ej: 295 R22.5"
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Modelo:</label>
            <input 
              type="text" 
              className="form-control"
              value={modelo}
              onChange={(e) => setModelo(e.target.value.toUpperCase())}
              placeholder="Ej: FATE"
            />
          </div>
        </div>
        
        <hr />

        <div className="mb-3">
          <label className="form-label"><strong>Descripción Final (Automática):</strong></label>
          <input 
            type="text" 
            className="form-control"
            value={descripcion}
            disabled 
            style={{ fontWeight: 'bold', backgroundColor: '#e9ecef' }}
          />
        </div>
        
        <button type="submit" className="btn btn-primary" disabled={isLoading}>
          {isLoading ? 'Creando...' : 'Crear Artículo en SAP'}
        </button>
      </form>

      {/* --- Zona de Resultados --- */}
      <div className="mt-4">
        {nuevoCodigoSAP && (
          <div className="alert alert-success">
            ✅ ¡Éxito! Nuevo código SAP: <strong>{nuevoCodigoSAP}</strong>
          </div>
        )}
        {error && (
          <div className="alert alert-danger">
            ❌ Error: {error}
          </div>
        )}
      </div>
    </div>
  );
}

export default CreacionArticuloForm;